var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('hb-icon',_vm._g(_vm._b({},'hb-icon',attrs,false),_vm.getListeners(on)),[_vm._v(" "+_vm._s(_vm.icon)+" ")])]}}])},[_c(_vm.mountedComponent,_vm._b({tag:"component"},'component',_vm.componentProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }